import {useEffect, useRef} from 'react';
import {COMMAND_PRIORITY_LOW, $isRangeSelection, $getSelection} from 'lexical';
import {SET_TEXT_COLOR} from '../../../../../Form/components/HTMLFormEditor/Editor/commands';
import {$patchStyleText} from '@lexical/selection';
import {useEventCallback} from 'usehooks-ts';
import {IPluginHooks} from '../ToolbarPlugin/types';

export const useCustomFontColorCommand = ({editor}: IPluginHooks) => {
    const lastSelectedColor = useRef('#000000');

    useEffect(() => {
        // Register FontColor command
        const unregisterFontColor = editor.registerCommand(
            SET_TEXT_COLOR,
            (payload?: Record<string, string>) => {
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    const styles = payload || {color: lastSelectedColor.current};
                    lastSelectedColor.current = styles.color;
                    $patchStyleText(selection, styles);
                }
                return false;
            },
            COMMAND_PRIORITY_LOW
        );

        // Cleanup on unmount
        return () => {
            unregisterFontColor();
        };
    }, [editor]);

    const onFontColorSelect = useEventCallback((color?: string) => {
        editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                const styles = color || lastSelectedColor.current;
                lastSelectedColor.current = color;
                $patchStyleText(selection, {color: styles});
            }
        });
    });

    return {lastSelectedColor, onFontColorSelect} as const;
};
